export interface ModuleGridViewportConfig {
  readonly gridHeight: number;
  readonly visibleRows: number;
  readonly anchorY: number;
}

export function computeModuleGridVisibleRowStart(config: ModuleGridViewportConfig): number {
  const rows = Math.min(config.visibleRows, config.gridHeight);
  const centered = config.anchorY - Math.floor(rows / 2);
  return Math.min(Math.max(0, centered), Math.max(0, config.gridHeight - rows));
}

export function isModuleGridRowVisible(
  y: number,
  visibleRowStart: number,
  gridHeight: number,
  visibleRows: number,
): boolean {
  return y >= visibleRowStart && y < visibleRowStart + Math.min(visibleRows, gridHeight);
}

export function moduleGridViewportRowY(y: number, visibleRowStart: number, step: number): number {
  return (y - visibleRowStart) * step;
}
